export const logo = document.createElement("a");
logo.setAttribute("href", "#");
logo.classList.add("logo", "link");
logo.innerText = "Beauty-lab";
